function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useApolloClient, useMutation } from "@apollo/client";
import { useNavigation, useRoute } from "@react-navigation/core";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Linking, Platform } from "react-native";
import { graphql } from "@oui/lib/src/graphql/tada";
import { AuthScreenContainer } from "../components/AuthScreenContainer";
import { Button } from "../components/Button";
import { ErrorPresenter } from "../components/ErrorPresenter";
import { Link } from "../components/Link";
import { Text } from "../components/Text";
import { EmailInput, TextInput } from "../components/TextInput";
import { View } from "../components/View";
import { manifest } from "../constants";
import { useForm } from "../hooks/useForm";
import { authClient } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { firebaseErrors, isFirebaseErrorKey } from "../lib/isFirebaseErrorKey";
import { logEvent } from "../lib/log";
import { setDeviceInfo } from "../lib/setDeviceInfo";
import { useTheme } from "../styles";
export var ClaimSignupTokenFromActivationCodeMutation = graphql("\n  mutation ClaimSignupTokenFromActivationCode($token: String!, $password: String!, $email: String) {\n    updateOuiUserWithToken(value: $token, input: { email: $email, password: $password }) {\n      username\n    }\n  }\n");
/**
 * Allows user to claim a previously created account and set a password given a
 * valid API `Token`. Also gives the user an opportunity to update their email
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-147}
 */ export function SignUp() {
    var route = useRoute();
    var navigation = useNavigation();
    var theme = useTheme().theme;
    var _route_params;
    var _ref = (_route_params = route.params) !== null && _route_params !== void 0 ? _route_params : {}, signupTokenFromActivationCode = _ref.signupTokenFromActivationCode, email = _ref.email;
    var _useForm = useForm({
        email: email !== null && email !== void 0 ? email : '',
        password: '',
        passwordConfirmation: ''
    }), bind = _useForm.bind, data = _useForm.data, validate = _useForm.validate, humanErrors = _useForm.humanErrors;
    var _useMutation = _sliced_to_array(useMutation(ClaimSignupTokenFromActivationCodeMutation), 1), claimSignupTokenFromActivationCode = _useMutation[0];
    var emailInputRef = useRef(null);
    var passwordInputRef = useRef(null);
    var confirmationInputRef = useRef(null);
    var $t = useI18n().$t;
    var apollo = useApolloClient();
    var passwordSetSuccessfullyRef = useRef(false);
    var _useState = _sliced_to_array(useState(''), 2), error = _useState[0], setError = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var replace = navigation.replace;
    useEffect(function() {
        if (Platform.OS === 'web' && !signupTokenFromActivationCode) {
            replace('Login', {});
        }
    }, [
        signupTokenFromActivationCode,
        replace
    ]);
    var request = function() {
        if (!validate()) return;
        if (data.password !== data.passwordConfirmation) {
            setError('Your password and password confirmation do not match');
            return;
        }
        if (signupTokenFromActivationCode) {
            setIsLoading(true);
            logEvent('claim_account');
            var promise = passwordSetSuccessfullyRef.current === true ? Promise.resolve() : claimSignupTokenFromActivationCode({
                variables: {
                    token: signupTokenFromActivationCode,
                    password: data.password,
                    email: data.email
                }
            });
            return promise.then(function() {
                return passwordSetSuccessfullyRef.current = true;
            }).then(function() {
                return authClient.login(data.email, data.password);
            }).then(function() {
                // dont need to wait for this, can be async... best effort reporting of device info
                void setDeviceInfo(apollo);
            }).catch(function(e) {
                var gqlErrors = e.graphQLErrors;
                var message = e.message;
                if (gqlErrors === null || gqlErrors === void 0 ? void 0 : gqlErrors[0].message) {
                    setError(gqlErrors === null || gqlErrors === void 0 ? void 0 : gqlErrors[0].message);
                } else if (isFirebaseErrorKey(message)) {
                    setError($t(firebaseErrors[message]));
                } else {
                    setError(message);
                }
                setIsLoading(false);
            });
        }
        return;
    };
    return /*#__PURE__*/ _jsx(AuthScreenContainer, {
        testID: "SignUp",
        heading: $t({
            id: 'Signup_title',
            defaultMessage: 'Create your account'
        }),
        children: /*#__PURE__*/ _jsx(View, {
            style: {
                paddingHorizontal: 14,
                flex: 1,
                marginTop: 20
            },
            children: signupTokenFromActivationCode ? /*#__PURE__*/ _jsxs(View, {
                spacing: 10,
                children: [
                    /*#__PURE__*/ _jsx(ErrorPresenter, {
                        errorString: error,
                        formErrors: humanErrors
                    }),
                    signupTokenFromActivationCode ? /*#__PURE__*/ _jsx(EmailInput, _object_spread_props(_object_spread({}, bind('email', {
                        validator: {
                            type: 'email'
                        },
                        label: $t({
                            id: 'Signup_emailLabel',
                            defaultMessage: 'Email'
                        })
                    })), {
                        ref: emailInputRef,
                        onSubmitEditing: function() {
                            var _passwordInputRef_current;
                            return (_passwordInputRef_current = passwordInputRef.current) === null || _passwordInputRef_current === void 0 ? void 0 : _passwordInputRef_current.focus();
                        },
                        enterKeyHint: "next",
                        testID: "Signup_emailInput"
                    })) : null,
                    /*#__PURE__*/ _jsx(View, {
                        children: /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({
                            secureTextEntry: true,
                            autoComplete: "new-password",
                            placeholder: $t({
                                id: 'Signup_passwordPlaceholder',
                                defaultMessage: 'Password'
                            })
                        }, bind('password', {
                            label: $t({
                                id: 'Signup_passwordLabel',
                                defaultMessage: 'Set a password'
                            }),
                            validator: [
                                {
                                    type: 'present'
                                },
                                {
                                    type: 'length',
                                    minimum: 8
                                }
                            ]
                        })), {
                            hint: $t({
                                id: 'Signup_passwordHint',
                                defaultMessage: 'Must be at least 8 characters'
                            }),
                            ref: passwordInputRef,
                            onSubmitEditing: function() {
                                var _confirmationInputRef_current;
                                return (_confirmationInputRef_current = confirmationInputRef.current) === null || _confirmationInputRef_current === void 0 ? void 0 : _confirmationInputRef_current.focus();
                            },
                            enterKeyHint: "next",
                            testID: "Signup_passwordInput"
                        }))
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        children: /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({
                            secureTextEntry: true,
                            placeholder: $t({
                                id: 'Signup_confirmPasswordPlaceholder',
                                defaultMessage: 'Confirm password'
                            })
                        }, bind('passwordConfirmation', {
                            label: $t({
                                id: 'Signup_confirmPasswordLabel',
                                defaultMessage: 'Confirm password'
                            })
                        })), {
                            enterKeyHint: "done",
                            ref: confirmationInputRef,
                            onSubmitEditing: function() {
                                return void request();
                            },
                            testID: "Signup_passwordConfirmationInput"
                        }))
                    }),
                    error ? /*#__PURE__*/ _jsx(Text, {
                        text: error,
                        color: theme.color.danger
                    }) : null,
                    /*#__PURE__*/ _jsx(View, {
                        row: true,
                        style: {
                            justifyContent: 'center',
                            marginBottom: 12
                        },
                        children: /*#__PURE__*/ _jsx(Link, {
                            textAlign: "center",
                            text: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "Signup_termsOfService",
                                defaultMessage: "By creating an account you agree to the {appName} <link>Terms of Service & Privacy Policy</link>.",
                                values: {
                                    appName: manifest.name,
                                    link: function(chunks) {
                                        return /*#__PURE__*/ _jsx(Link, {
                                            text: chunks.join(''),
                                            onPress: function() {
                                                void Linking.openURL('https://about.oui.health/terms-and-privacy');
                                            }
                                        });
                                    }
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        testID: "Signup_loginButton",
                        onPress: request,
                        disabled: !data.password || !data.passwordConfirmation || isLoading,
                        alignSelf: "flex-end",
                        style: {
                            paddingHorizontal: 16
                        },
                        text: $t({
                            id: 'Signup_loginButton',
                            defaultMessage: 'Login'
                        }),
                        iconRight: "arrow-right"
                    })
                ]
            }) : null
        })
    });
}
